import clsx from "clsx";
import { FC, useState } from "react";
import { Asset, MsgExec } from "rujira.js";
import { DenomInput, i18n, Toggle, Warning } from "rujira.ui";
import exclamation from "rujira.ui/src/assets/images/exclamation.gif";
import { Info } from "rujira.ui/src/components/icons/Icons";
import {
  BalanceCompact,
  BalanceProvider,
} from "../../common/components/Balance";
import {
  MsgProvider,
  TxBalanceAccountButton,
} from "../../common/components/TxButton";
import { msgAssetFragment$key } from "../../services/__generated__/msgAssetFragment.graphql";
import { useAccounts } from "../../services/accounts";
import { useMsgAssetFragment } from "../../services/msg";

export const PerpsDeposit: FC<{
  address: string;
  quote: msgAssetFragment$key;
}> = ({ address, quote }) => {
  const asset = useMsgAssetFragment(quote);
  const [amount, setAmount] = useState(0n);
  const [type, setType] = useState<"lp" | "xlp">("lp");

  return (
    <BalanceProvider asset={asset}>
      <div className="card h-full p-3">
        {/* {balances?.id && (
        <Subscription id={balances.id} subscription={subscription} />
      )} */}
        <i18n.h3 className="fs-16 lh-22 fw-400 color-grey">Provide</i18n.h3>
        <div className="flex tabs mt-2 ai-c">
          <a
            className={clsx({ selected: type === "lp" })}
            onClick={() => setType("lp")}>
            LP
          </a>
          <a
            className={clsx({ selected: type === "xlp" })}
            onClick={() => setType("xlp")}>
            xLP
          </a>
          {type === "xlp" && (
            <p className="fs-14 color-grey ml-2">
              xLP has a 45-day unlock period
            </p>
          )}
        </div>
        <BalanceCompact onClick={(x) => setAmount(x.balance)} />

        <DenomInput
          symbol={asset.metadata.symbol}
          className="mt-1"
          amount={amount}
          decimals={asset.metadata.decimals}
          onChangeAmount={(x) => {
            setAmount(x);
          }}
          maxLabel={`${i18n.t("Balance")}:`}
        />
        {type === "xlp" && (
          <Warning
            className="warning--sm mt-2 condensed flex ai-c"
            color="orange">
            <img
              src={exclamation}
              alt=""
              className="filter-orange block no-shrink"
              style={{ width: "2.5rem", height: "2.5rem" }}
            />
            <div className="text-left">
              You have selected xLP, your deposit will be subject to 45 days
              unlock period.
            </div>
          </Warning>
        )}
        <Estimate
          address={address}
          amount={amount}
          asset={asset}
          liquidityType={type}
        />
      </div>
    </BalanceProvider>
  );
};

const Estimate: FC<{
  address: string;
  amount: bigint;
  asset: Asset;
  liquidityType: "lp" | "xlp";
}> = ({ address, amount, asset, liquidityType }) => {
  const [accept, setAccept] = useState(false);
  const { selected } = useAccounts();
  const msg =
    accept && selected
      ? new MsgExec(
          { address: selected.address, network: "THOR" },
          asset,
          amount,
          address,
          {
            deposit_liquidity: {
              stake_to_xlp: liquidityType === "xlp",
            },
          }
        )
      : null;

  return (
    <MsgProvider msg={msg}>
      <div className="row wrap dir-r pad-mini condensed fs-14 ai-c mt-1.5">
        <div className="text-center text-xs-left color-grey fw-500 py-0.5">
          <div className="iflex ai-c no-select">
            Your unutilized liquidity can be withdrawn
            <Info className="ml-0.5 block w-2.5" />
          </div>
        </div>
      </div>
      <div className="flex wrap ai-s mt-1">
        <Toggle
          checked={accept}
          onChange={(e) => {
            setAccept(e.currentTarget.checked);
          }}
          className="mt-2 toggle--small ai-c">
          <span className="toggle__label">
            I accept the{" "}
            <a
              href="/tou"
              target="_blank"
              className="color-white hover-primary1">
              terms of use
            </a>
          </span>
        </Toggle>
        <div className="mt-1 block ml-a text-right">
          <TxBalanceAccountButton
            required={{ asset, amount }}
            label="Deposit to Pool"
          />
        </div>
      </div>
    </MsgProvider>
  );
};
